import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { of, zip } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  IRoute,
  Pattern,
  TokenService
} from 'viggo-sistemas-core-web';

import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';
import {
  IProprietarioVeiculo,
  TIPO_TAC
} from '@app/modules/proprietario_veiculo/models/proprietario_veiculo.model';
import { ProprietarioVeiculoService } from '@app/modules/proprietario_veiculo/services/proprietario_veiculo.service';
import { Utils } from '@app/shared/helpers/utils';

import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Dialog } from 'primeng/dialog';
import {
  validateCnpj,
  validateCpf
} from '../../../../shared/utils/validators_cpf_cnpj';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';

@Component({
  selector: 'app-fast-proprietario-veiculo',
  templateUrl: './fast-proprietario-veiculo.component.html',
  styleUrls: ['./fast-proprietario-veiculo.component.scss'],
  providers: [ParceiroService, ProprietarioVeiculoService]
})
export class FastProprietarioVeiculoComponent implements OnInit, AfterViewInit {
  @ViewChild('fastPropVeic') fastPropVeic: Dialog;
  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  form: UntypedFormGroup;
  findParceiro = false;
  loadingParceiro = false;
  tipoTAC: { label: string; value: string }[];

  messages = {
    cpf_cnpj: {
      repeated: 'Informação já cadastrada.',
      mask: 'Valor inválido.',
      required: 'O CPF/CNPJ é obrigatório',
      pattern: 'Este CPF/CNPJ é inválido.',
      maxlength: 'O CPF/CNPJ deve conter no máximo 14 caracteres.',
      validateCPF: 'Este CPF é inválido.',
      validateCNPJ: 'Este CNPJ é inválido.',
      duplicate:
        'CPF/CNPJ já existe na base de dados. Verifique se o cadastro existente com esse dado esta correto.'
    },
    apelido_nome_fantasia: {
      required: 'Esta informação é obrigatória.',
      minlength: 'Este nome é muito curto',
      maxlength: 'Este nome é muito longo.',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    nome_razao_social: {
      required: 'Esta informação é obrigatória.',
      maxlength: 'O nome deve conter no máximo 60 caracteres',
      minlength: 'Esta razão social é muito curta.',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    rntrc: {
      maxlength: 'O nome deve conter no máximo 30 caracteres.',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    taf: {
      maxlength: 'O nome deve conter no máximo 12 caracteres.',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    registro_estadual: {
      maxlength: 'O nome deve conter no máximo 25 caracteres.',
      isEmptyValue: 'Valor inválido, remova os espaços!',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    },
    rg: {
      pattern: 'Este RG é invalido.',
      maxlength: 'O RG deve conter no máximo 20 caracteres.',
      existSpecialChar: 'Valor inválido, não aceita pontuação!',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    rg_insc_est: {
      pattern: 'Este valor é inválido.',
      maxlength: 'O campo deve conter no máximo 20 caracteres.',
      duplicate: 'O RG/Insc. Estadual já existe na base de dados!',
      existSpecialChar: 'Valor inválido, não aceita pontuação!',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    }
  };

  viewInit = false;

  entity: IProprietarioVeiculo = {
    parceiro: {
      contatos: [],
      enderecos: []
    } as IParceiro
  } as IProprietarioVeiculo;

  constructor(
    public dialogRef: MatDialogRef<FastProprietarioVeiculoComponent>,
    public entityService: ProprietarioVeiculoService,
    protected tokenService: TokenService,
    private parceiroService: ParceiroService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router,
    private fb: UntypedFormBuilder
  ) {
    this.tipoTAC = Utils.enumToLisObjet(TIPO_TAC);
  }

  ngOnInit() {
    this.form = this.fb.group({
      nome_razao_social: [
        this.entity.parceiro.nome_razao_social || '',
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(1),
          CustomValidators.isEmptyValue()
        ]
      ],
      apelido_nome_fantasia: [
        this.entity.parceiro.apelido_nome_fantasia || '',
        [
          Validators.minLength(1),
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      cpf_cnpj: [this.entity.parceiro.cpf_cnpj || '', [Validators.required]],
      rg_insc_est: [
        this.entity.parceiro.rg_insc_est || '',
        [
          Validators.pattern(Pattern.patternInscEstadual()),
          Validators.maxLength(20),
          CustomValidators.existSpecialChar(),
          CustomValidators.isEmptyValue()
        ]
      ],
      codigo: [this.entity.codigo || ''],
      rntrc: [
        this.entity.rntrc || '',
        [Validators.maxLength(30), CustomValidators.isEmptyValue()]
      ],
      taf: [
        this.entity.taf || '',
        [Validators.maxLength(12), CustomValidators.isEmptyValue()]
      ],
      registro_estadual: [
        this.entity.registro_estadual || '',
        [
          Validators.maxLength(25),
          CustomValidators.isEmptyValue(),
          CustomValidators.existSpecialChar()
        ]
      ],
      tipo_tac: [this.entity.tipo_tac || 'AGREGADO']
    });
    this.form.controls.cpf_cnpj.valueChanges.subscribe(() => {
      this.validar();
    });
  }

  validar() {
    const cpfCnpjValue = this.form.controls.cpf_cnpj.value;
    if (cpfCnpjValue.toString().length <= 11) {
      if (validateCpf(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCPF: true });
        this.form.updateValueAndValidity();
      }
    } else if (validateCnpj(cpfCnpjValue)) {
      this.form.controls.cpf_cnpj.setErrors({ validateCNPJ: true });
      this.form.updateValueAndValidity();
    }
  }

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return this.viewInit && this._fastEndereco.form.valid && this.form.valid;
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.form.invalid) this.form.markAllAsTouched();
    return this.viewInit && this.form.invalid;
  }

  notText(event) {
    if (
      (!/^\d+$/.test(event.key) || /[`,.]/.test(event.key)) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      !event.ctrlKey
    )
      return false;
  }

  public checkRgInscEstadual(): void {
    const rgInsc = this.form.controls.rg_insc_est;

    if (
      rgInsc.value === null ||
      rgInsc.invalid ||
      rgInsc.value === '' ||
      this.findParceiro
    )
      return;
    const rgInscValue: string = rgInsc.value.replace(/[^a-zA-Z0-9 ]/g, '');

    this.parceiroService
      .getEntitiesByParams(
        `rg_insc_est=${rgInscValue}`,
        this.tokenService.getDomain().id
      )
      .subscribe(
        (parceiro: IParceiro) => {
          if (parceiro[0] && parceiro[0].id) {
            this.form.controls.rg_insc_est.setErrors({ duplicate: true });
            this.form.updateValueAndValidity();
            return {} as IParceiro;
          }
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  public checkCpfCnpj(): void {
    const cpfCnpj = this.form.controls.cpf_cnpj;

    if (cpfCnpj.invalid || !cpfCnpj.value || cpfCnpj.value === undefined)
      return;
    const cpfCnpjValue: string = cpfCnpj.value;
    this.loadingParceiro = true;

    this.parceiroService
      .getEntitiesByParams(
        `cpf_cnpj=${cpfCnpjValue}`,
        this.tokenService.getDomain().id
      )
      .pipe(
        map(parceiros => {
          if (parceiros.length) {
            this.findParceiro = true;
            return { ...parceiros[0], cpf_cnpj: parceiros[0].cpf_cnpj.trim() };
          }
          this.findParceiro = false;
          return { contatos: [], enderecos: [] } as IParceiro;
        }),
        mergeMap(parceiro => {
          if (!parceiro || !parceiro.id || parceiro.id === this.entity.id)
            return of(parceiro);
          return this.entityService.getEntity(parceiro.id).pipe(
            map(ent => {
              if (ent && ent.id) {
                this.form.controls.cpf_cnpj.setErrors({ duplicate: true });
                this.form.updateValueAndValidity();
                return { contatos: [], enderecos: [] } as IParceiro;
              }
              return parceiro;
            }),
            catchError(() => of(parceiro))
          );
        })
      )
      .subscribe(
        (parceiro: IParceiro) => {
          this.loadingParceiro = false;
          if (!parceiro || !parceiro.id) {
            this.entity.parceiro.id = null;
            return;
          } else {
            this.setInformacoesParceiro(parceiro);
            this.form.patchValue({
              apelido_nome_fantasia: parceiro.apelido_nome_fantasia || null,
              nome_razao_social: parceiro.nome_razao_social || null,
              rg_insc_est: parceiro.rg_insc_est || null,
              data_nascimento: parceiro.data_nascimento || null
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.loadingParceiro = false;
          this.displayError(err);
        }
      );
  }

  onSubmit(): void {
    const entity: IProprietarioVeiculo | any = Utils.clearObject<
      IProprietarioVeiculo
    >({
      ...this.entity,
      parceiro: Utils.clearObject({
        ...this.entity.parceiro,
        ...this.form.value,
        enderecos: this._fastEndereco.getValues(),
        contatos: this._fastContato.getValues()
      }),
      rntrc: this.form.value.rntrc,
      taf: this.form.value.taf,
      registro_estadual: this.form.value.registro_estadual,
      tipo_tac: this.form.value.tipo_tac,
      domain_id: this.tokenService.getDomain().id
    } as IProprietarioVeiculo);
    entity.parceiro = Utils.trimAttributes(entity.parceiro);
    entity.parceiro = Utils.clearEmptyString(entity.parceiro);
    this.insert(entity);
  }

  insert(entity: IProprietarioVeiculo): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.entityService.insert({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, proprietario]) => {
            return this.entityService.getEntity(proprietario.id, ['parceiro']);
          })
        )
        .subscribe(
          proprietario => {
            this.matSnackBar.open('Proprietário criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(proprietario);
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.entityService.insert({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(proprietario => {
            return this.entityService.getEntity(proprietario.id, ['parceiro']);
          })
        )
        .subscribe(
          proprietario => {
            this.matSnackBar.open('Proprietário criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(proprietario);
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    }
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
    this.fastPropVeic.maximize();
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
